import { Check } from 'lucide-react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center">
      {steps.map((step, index) => {
        const isCompleted = step < currentStep;
        const isCurrent = step === currentStep;

        return (
          <div key={step} className="flex items-center">
            {/* Step Circle */}
            <div
              className={`flex items-center justify-center w-8 h-8 rounded-full border-2 transition-colors ${
                isCompleted
                  ? 'bg-[#E34290] text-white border-[#E34290]'
                  : isCurrent
                    ? 'border-[#E34290] text-[#E34290] bg-white dark:bg-gray-800'
                    : 'border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500 bg-white dark:bg-gray-800'
              }`}
            >
              {isCompleted ? (
                <Check className="w-4 h-4" />
              ) : (
                <span className="text-sm font-medium">{step}</span>
              )}
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div className="flex items-center justify-center w-16 px-2">
                <div
                  className={`w-12 h-0.5 transition-colors ${
                    isCompleted ? 'bg-[#E34290]' : 'bg-gray-200 dark:bg-gray-700'
                  }`}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
